import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ThreadIcon = React.forwardRef(function ThreadIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M4 4H20C21 4 23 3 23 1.5 23 0 22 0 21 0H3C2 0 1 0 1 1.5 1 3 3 4 4 4ZM20 20H4C3 20 1 21 1 22.5 1 24 2 24 3 24H21C22 24 23 24 23 22.5 23 21 21 20 20 20ZM19 16H5C4.45 16 4 16.45 4 17 4 17.55 4.45 18 5 18H19C19.55 18 20 17.55 20 17 20 16.45 19.55 16 19 16ZM19 11H5C4.45 11 4 11.45 4 12 4 12.55 4.45 13 5 13H19C19.55 13 20 12.55 20 12 20 11.45 19.55 11 19 11ZM19 6H5C4.45 6 4 6.45 4 7 4 7.55 4.45 8 5 8H19C19.55 8 20 7.55 20 7 20 6.45 19.55 6 19 6Z"></path>
    </svg>
  )
})

ThreadIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ThreadIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ThreadIcon
